import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { IConBecomeStar, IConCircle, IConClose } from "@components";
import { IMembershipTier } from "@interfaces";
import { selectApp, selectMerchant } from "@redux";

interface IProps {
    membershipTier: IMembershipTier;
    handleClose: () => void;
}

export const ComponentCurrentPoint = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //page props
    const { membershipTier, handleClose } = props;
    const { themes } = useSelector(selectMerchant);
    const { langSetting } = useSelector(selectApp);

    return (
        <StyledCurrentPoint borderBottom={!!membershipTier?.benefits?.length}>
            <div className="content_currentPoint">
                <div className="close" onClick={handleClose}>
                    <IConClose width={18} />
                </div>
                <div className="title">
                    <div className="image">
                        <IConBecomeStar size={24} color={themes?.themeColor!} />
                    </div>
                    <div className="member text-sub-header">
                        {membershipTier.membershipName} {t("page._member")}
                    </div>
                </div>
                <div className="baht_spent text-body">
                    {membershipTier.bahtSpent}{t("page.baht")} {t("page._spent")} = {membershipTier.points}{" "}
                    {t("page._points")}
                </div>
                {membershipTier?.benefits?.length !== 0 && (
                    <div className="benefits">
                        {membershipTier?.benefits?.map((benefit) => {
                            return (
                                <>
                                    <div className="circle">
                                        <div className="icon-">
                                            <IConCircle color={themes?.themeColor!} />
                                        </div>
                                        <span>{benefit}</span>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                )}
            </div>
        </StyledCurrentPoint>
    );
};

const StyledCurrentPoint = styled.div<{ borderBottom: boolean }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .content_currentPoint {
        background: ${(p) => p.theme.colors.card};
        padding: 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: auto;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
    .baht_spent {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        color: #7e7e7e;
        padding: 8px 0 16px 0;
        ${(p) => {
        if (p.borderBottom) return "border-bottom: 1px solid rgba(112, 112, 112, 0.31);";
    }}
    }
    .benefits {
        margin-top: 16px;
        .circle {
            display: flex;

            margin-top: 20px;

            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 1.5rem;
            color: #000000;
            span {
                display: inline-block;
                margin-left: 12px;
                line-height: 20px;
            }
        }
    }
`;
